export enum CardType {
    visa = 'VISA',
    masterCard = 'MasterCard',
    amex = 'Amex',
    discover = 'Discover'
}
